export const checkPermissions = (checkPermission, permissions) => {
    if (!Array.isArray(checkPermission)) throw new Error('permissions must be array');
    if (checkPermission.length === 0) return false;
    return checkPermission.every(p => permissions.includes(p));
}
